import { makeStyles, tokens } from '@fluentui/react-components';

export const useEmptyStateIconStyles = makeStyles({
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    '> svg': {
      height: 'inherit',
      width: 'inherit',
    },
  },
  largeSurface: {
    marginBottom: tokens.spacingVerticalL,
    width: '192px',
  },
  mediumSurface: {
    marginBottom: tokens.spacingVerticalM,
    width: '128px',
  },
  mediumMenu: {
    marginBottom: tokens.spacingVerticalS,
    width: '48px',
  },
  smallMenu: {
    marginBottom: tokens.spacingVerticalSNudge,
    width: '24px',
  },
});
